import React from 'react'
import { useCreateScopeSequenceTree } from './hooks'
import { Box, Button, Input, Typography } from '@mui/material'
import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  commonCoreFrameworkAtom,
  newTreeAttributionAtom,
  newTreeTitleAtom,
  treeCreateFlowIdAtom,
} from './atoms'
import { FlowIdView } from 'components/contentService/JobView'
import { pluralizeCount } from 'shared/utils'
import { AttributionSelector } from 'shared/ui'
import { useSubjectsById } from 'api/subjects.atoms'

export function TreeCreationDetails() {
  const { canCreate, doCreate, totalLessons, totalUnits } =
    useCreateScopeSequenceTree()
  const flowId = useAtomValue(treeCreateFlowIdAtom)
  const [treeTitle, setTreeTitle] = useAtom(newTreeTitleAtom)
  const [attribution, setAttribution] = useAtom(newTreeAttributionAtom)
  const commonCoreFramework = useAtomValue(commonCoreFrameworkAtom)
  const subjectsById = useSubjectsById()
  const subjectName =
    commonCoreFramework?.subject_id != null
      ? subjectsById?.[commonCoreFramework.subject_id]?.subject_name
      : undefined

  if (!canCreate) {
    return (
      <Box>
        When the Tree Structure is created you can verify and then create the
        tree.
      </Box>
    )
  }

  return (
    <Box>
      <Box>
        <Button disabled={!!flowId} onClick={doCreate}>
          Create Tree
        </Button>
      </Box>
      <Box mb={3}>
        <label
          htmlFor="tree-title"
          style={{ display: 'block', marginBottom: 4 }}
        >
          <strong>Tree title</strong>
        </label>
        <Input
          id="tree-title"
          value={treeTitle}
          onChange={(e) => setTreeTitle(e.target.value)}
          placeholder="Enter a title for the tree"
          disabled={!!flowId}
        />
      </Box>
      <Box mb={3}>
        <AttributionSelector value={attribution} onChange={setAttribution} />
      </Box>
      {subjectName && (
        <Box mb={3}>
          <Typography variant="body2" color="textSecondary">
            <strong>Subject:</strong> {subjectName}
          </Typography>
        </Box>
      )}
      <Box>{`Creating ${pluralizeCount('Lesson', totalLessons)} Across ${pluralizeCount('Unit', totalUnits)}`}</Box>
      <Box>
        <FlowIdView flowId={flowId} />
      </Box>
    </Box>
  )
}
